export const REST_URL_AGENT = "/rest/admin/agent";
export const REST_URL_CONNECTION = "/rest/admin/connection";
export const REST_URL_OFFER = "/rest/admin/offer/discount";
export const REST_URL_NOTIFICATION = "/rest/admin/notification";
export const REST_URL_POST = "/rest/admin/content/post";
export const REST_URL_USER = "/rest/admin/user";
export const REST_URL_VALIDATION = "/rest/admin/network/validation";